<template>
  <div class="goods-tag-container" id="print-goods-tag-list">
    <div class="goods-tag-item" v-for="(item, index) in goodsList" :key="index">
      <div class="goods-tag-left">
        <div class="goods-name">{{ item.goodsName }}</div>
        <div class="sku-name">{{ item.skuListStr }}</div>
        <div class="sku-name">单品编号：{{ item.spuSn }}</div>
        <div class="date">保质期：{{ item.qualityGuaranteePeriod }}天</div>
        <div class="date">生产日期：{{ item.manufactureDate }}</div>
        <div class="company-name">{{generateCryptoPrice(item.costPrice)}}</div>
      </div>
      <div class="goods-tag-right">
        <img class="qr-code" :src="item.qrCodeBase64" alt="商品二维码">
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcode"
import { timeSlice } from "@/utils/common"
import printJS from "print-js"
export default {
  props: {
    spuList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    spuList: {
      handler() {
        this.renderGoodsList()
      },
      immediate: true
    }
  },
  data() {
    return {
      goodsList: []
    }
  },
  methods: {
    // 生成模糊的成本单价
    generateCryptoPrice(price) {
      // 不存在小数点 则 补充小数点
      if (price.indexOf(".") === -1) {
        price = price + ".00"
      }
      // 将小数 分隔成 两部分
      const priceArr = price.split(".")
      let priceInt = priceArr[0] // 整数部分
      let priceDec = priceArr[1] // 小数部分
      const intNum = priceInt.length // 整数位的长度
      const firstNum = String(intNum).length //第一位数字记录 整数位长度 是几位数
      if (intNum < 6) {
        const digits = 6 - intNum
        const randomNumInt = this.generateNumber(digits)
        priceInt = randomNumInt + priceInt
      }
      const randomNumDec = this.generateNumber(4)
      priceDec = priceDec + randomNumDec

      const randomNumLeft = this.generateNumber(5 - Number(firstNum)) // 左边补充的随机数字
      const leftNum = String(firstNum) + String(intNum) + String(randomNumLeft)
      return `${leftNum} ${priceInt} ${priceDec}`
    },
    // 生成随机位数
    generateNumber(digits) {
      if (digits <= 0 || !Number.isInteger(digits)) {
        throw new Error("参数必须是正整数")
      }
    
      const min = Math.pow(10, digits - 1)
      const max = Math.pow(10, digits) - 1
    
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    print() {
      printJS({
        printable: "print-goods-tag-list",
        type: "html",
        targetStyles: ["*"],
        scanStyles: false,
        style: `
          .goods-tag-item {
            width: 60mm;
            height: 38mm;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            position: relative;
          }
          .goods-tag-item .goods-tag-left {
            flex-grow: 1;
          }
          .goods-tag-item .goods-tag-left .goods-name {
            font-weight: bold;
            font-size: 8px;
          }
          .goods-tag-item .goods-tag-left .sku-name,
          .goods-tag-item .goods-tag-left .date,
          .goods-tag-item .goods-tag-left .company-name {
            font-size: 8px;
            margin-top: 1mm;
          }
          .goods-tag-item .goods-tag-right {
            flex-shrink: 0;
            margin-right: 2mm;
          }
          .goods-tag-item .goods-tag-right .qr-code {
            width: 20mm;
            height: 20mm;
          }
          
          @media print {
            .goods-tag-container .goods-tag-item { 
              page-break-after: always;
            }
          }
        `
      })
    },
    renderGoodsList() {
      setTimeout(async res => {
        const goodsList = []
        this.goodsList = [] // 置空 避免 一直累加
        const list = JSON.parse(JSON.stringify(this.spuList))
        for (let i = 0; i < list.length; i++) {
          const item = list[i]
          const qrCodeText = process.env.VUE_APP_WMS_H5 + "/#/spu-detail/" + item.spuId + "?date=" + item.manufactureDate + "&randomNo=" + this.generateCryptoPrice(item.costPrice).replaceAll(" ", "Q")
          const qrCodeBase64 = await QRCode.toDataURL(qrCodeText)
          item.qrCodeBase64 = qrCodeBase64
          for (let j = 1; j <= item.entryNumber; j++) {
            goodsList.push(item)
          }
        }
        timeSlice(goodsList, (item) => {
          this.goodsList.push(item)
        }, this, () => {
          console.log("🚀 ~ renderGoodsList ~ this.visibleGoodsList:", this.goodsList)
        })
      }, 0)
    }
  }
}
</script>
<style lang="scss" scoped>
.goods-tag-container {
  position: absolute;
  height: 0;
  overflow: hidden;

  .goods-tag-item {
    width: 60mm;
    height: 30mm;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    .goods-tag-left {
      flex-grow: 1;

      .goods-name {
        font-weight: bold;
        font-size: 14px;
      }

      .sku-name,
      .date,
      .company-name {
        font-size: 12px;
        margin-top: 2mm;
      }
    }

    .goods-tag-right {
      flex-shrink: 0;

      .qr-code {
        width: 20mm;
        height: 20mm;
      }
    }
  }
}
</style>